import React from 'react';
import PictureImage from '../../../utils/Image/PictureImage';
import Slider from 'react-slick';
import { withContent } from '../../../hoc/withContext';
import { IContent } from '../../../types';
import { MobileGamePictureContainer, MobileSliderContainer } from './MobileSliderStyles';
import Fade from "react-reveal/Fade";

interface IGameSliderProps {
  context? : IContent;
}

const MobileSlider = ({context} : IGameSliderProps) => {
   const gameSelectionSliderConfig = {
      dots: false,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: true,
      speed: 100,
      adaptiveHeight: true,
      infinite: true,
      edgeFriction: 0.1,
      variableWidth: false,
      transformEnabled: false,
      slidesToShow: 1,
      initialSlide: 0,
    }
  ;

  return (
    <Fade center>
      <MobileSliderContainer>
        <Slider {...gameSelectionSliderConfig} >
          {context.gameSlider.game.map((image) => (

            <MobileGamePictureContainer key={'slide_' + image}>
              <PictureImage
                images={[{
                  imageName: image + '_mobile',
                  minWidth: 600
                }]}
                extension="png"
                altText={image}
                className={['']}
              />
            </MobileGamePictureContainer>

          ))}
        </Slider>
      </MobileSliderContainer>
    </Fade>
  );
};

export default withContent(MobileSlider);